import { useLocation } from "@tanstack/react-router";
import { useCallback, useEffect } from "react";

export interface RouteChangeEventDetail {
  path: string;
}

export type RouteChangeEvent = CustomEvent<RouteChangeEventDetail>;

export const useRouteChangeEvent = () => {
  const pathname = useLocation({ select: l => l.pathname });

  const fireRouteChangeEvent = useCallback(() => {
    const event: RouteChangeEvent = new CustomEvent("circle:route-change", {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: {
        path: pathname,
      },
    });

    document.dispatchEvent(event);
  }, [pathname]);

  useEffect(() => {
    fireRouteChangeEvent();
  }, [fireRouteChangeEvent]);
};
